import { action } from 'mobx';
import Alert from 'react-s-alert';
import i18next from 'i18next';
import { App, AppRegistry, ArrayApp } from 'core';
import { FormStore } from 'libs/forms/app';

import { LabelModel } from 'apps/issueTracker/models';

import { conf } from 'apps/issueTracker/config.yaml';
import { SmallThreeColumnLayout } from 'apps/layout';

export class LabelApp extends App {
  static registryName = 'LabelApp';
  static Model = LabelModel;
  newLabel() {
    this.newLabelForm = new FormStore(this, conf, 'newLabelForm');
  }
}
AppRegistry.add(LabelApp);

export class LabelsApp extends ArrayApp {
  static registryName = 'LabelsApp';
  static ElementApp = LabelApp;
  cardLayout = new SmallThreeColumnLayout();

  // FIXME - replace with this.find(({ id }) => id === label.id)
  // eslint-disable-next-line
    getDup(label) {
    // eslint-disable-next-line
      for (const t of this) {
      if (t.id === label.id) {
        return t;
      }
    }
  }

  @action Add = label => {
    const dup = this.getDup(label);
    if (dup) {
      if (dup.deleted) {
        dup.deleted = false;
      } else {
        const labelName = label.name;
        Alert.error(
          i18next.t("No need to add '{{labelName}}' twice!", { labelName }),
        );
      }
    } else {
      this.push(label);
    }
  };

  @action Delete = label => {
    if (this.upstream !== undefined && this.upstream.includes(label.upstream)) {
      // eslint-disable-next-line no-param-reassign
      label.deleted = true;
    } else {
      this.remove(label);
    }
  };
}
AppRegistry.add(LabelsApp);
